<template>
  <div class="crm">
    <page-header title="Hand-Off" breadcrumb="Booking & Shipment › Dispatch Timeline › Handoff" />
    <div class="">
      <!-- Incoming / Outgoing Tabs -->
      <div class="flex justify-between my-4 pt-8 border-b-[1px] border-[#B7BDCD]">
        <div class="flex">
          <div :class="{ active: currentTab == 'incoming' }" class="tab-item" @click="currentTab = 'incoming'">
            <p>Incoming</p>
          </div>
          <div :class="{ active: currentTab == 'outgoing' }" class="tab-item" @click="currentTab = 'outgoing'">
            <p>Outgoing</p>
          </div>

          <div :class="{ active: currentTab == 'history' }" class="tab-item" @click="currentTab = 'history'">
            <p>History</p>
          </div>
        </div>
      </div>

      <!-- Shipment Tabs -->

      <div class="flex justify-between my-4 pt-8 border-b-[1px] border-[#B7BDCD]">
        <div class="flex">
          <div :class="{ active: currentShipmentTab == 'consolidatedShipment' }" class="tab-item"
            @click="currentShipmentTab = 'consolidatedShipment'">
            <p>Consolidated Shipment</p>
          </div>
          <div :class="{ active: currentShipmentTab == 'singleShipment' }" class="tab-item"
            @click="currentShipmentTab = 'singleShipment'">
            <p>Single Shipment</p>
          </div>

        </div>
      </div>

      <div class="grid grid-cols-12 gap-5  metrics">

        <!-- Left -->
        <div class="col-span-6">

          <div class="grid grid-cols-2 gap-5">

            <div class="bg-white rounded-xl border pl-6  py-8">
              <p class="uppercase">
                Shipments Qty
              </p>

              <h2 class=" mt-3">
                {{handOffAnalytics?.summary?.shipmentQuantity || 0 }}
              </h2>
            </div>

            <div class="bg-white rounded-xl border pl-6  py-8">
              <p class="uppercase">
                Handoff Qty
              </p>

              <h2 class=" mt-3">
                {{handOffAnalytics?.summary?.handoffQuantity || 0 }}
              </h2>
            </div>

            <div class="bg-white rounded-xl border pl-6  py-8">
              <p class="uppercase">
                Total Weight (KG)
              </p>

              <h2 class=" mt-3">
                {{handOffAnalytics?.summary?.totalWeightKg || 0 }}
              </h2>
            </div>

            <div class="bg-white rounded-xl border pl-6  py-8">
              <p class="uppercase">
                Total Volume (M³)
              </p>

              <h2 class=" mt-3">
                {{handOffAnalytics?.summary?.totalVolume || 0 }}
              </h2>
            </div>

          </div>

        </div>

        <!-- Right -->
        <div class="col-span-6">

          <div class="bg-white rounded-xl border">

            <div class="flex items-center justify-between px-6 py-3 border-b">

              <div class="flex items-center gap-3">

                <div class="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
                  <svg width="18" height="18" fill="#F59E0B" viewBox="0 0 24 24">
                    <path d="M10 6h10v2H10zm0 10h10v2H10zM4 5a2 2 0 100 4 2 2 0 000-4zm0 10a2 2 0 100 4 2 2 0 000-4z" />
                  </svg>
                </div>

                <h3 class="">
                  Top Routes
                </h3>

              </div>

            </div>

            <div>

              <div v-for="(route, index) in routes" :key="index"
                class="flex justify-between items-center px-6 py-2 border-b last:border-b-0">

                <div class="flex items-center gap-4">

                  <h4 >
                    {{ String(index + 1).padStart(2, '0') }}
                  </h4>

                  <span >
                    {{ route?.route }}
                  </span>

                </div>

                <div class="text-right">

                  <p class="uppercase ">
                    Qty
                  </p>

                  <b class="font-bold text-gray-700">
                    {{ route?.handoffQuantity?.toLocaleString() }}
                  </b>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
      <!-- <pre>
      </pre> -->
      <!-- <div class="topline-wrapper px-2 py-2 ">
        <div class="topline px-3 flex flex-wrap justify-start">
          <div class="flex gap-2 topline-child">
            <CummulativeIcon />
            <p class="mt-2 font-bold">Cummulative</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">SHIPMENTS (QTY)</p>

            <p class="topline-value">{{ dispatchAnalytics.totalDispatchCount }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">DISPATCHES (M)</p>
            <p class="topline-value">{{ dispatchAnalytics.totalDispatchDistance }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">GROSS WEIGHT(KG)</p>
            <p class="topline-value">{{ dispatchAnalytics.totalDispatchWeight }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">Volume</p>
            <p class="topline-value">{{ dispatchAnalytics.totalDispatchVolume }}</p>
          </div>
        </div>

        <div class="topline px-3 flex flex-wrap justify-start">
          <div class="flex gap-2 topline-child">
            <TopRoutesIcon />
            <p class="mt-2 font-bold">Top Routes</p>
          </div>

          <div class="topline-child" v-for="(shippingservice, index) in (dispatchAnalytics.topRoutes || []).slice(0,4)" :key="index">
            
              <p class="topline-header">{{ shippingservice.routeName }} (QTY)</p>
              <p class="topline-value">{{ shippingservice.totalShipments ? shippingservice.totalShipments : 0 }}</p>
          </div>

        </div>
      </div> -->

      <!-- <div >
      <div v-if="currentTab === 'outgoing'" class="flex justify-end mt-12 mb-8 gap-4">
          <primary-button buttonText="Dispatch" :loading="false" @click="$router.push({ name: 'NewDispatch' })" />
          <button class="mr-4 px-4 font-bold text-white pale-blue" @click="$router.push({ name : 'Requests'})">Request</button>
      </div>
      <div v-else class="flex justify-end mt-12 mb-8 gap-4">
          <button class="mr-4 px-5 rounded-md font-bold text-white pale-blue" @click="$router.push({ name : 'Requests'})">All Requests</button>
      </div>
      </div> -->

      <!-- <dispatch-table class="mt-5" :currentTab="currentTab" /> -->
      <hand-off-table class="mt-5" :currentTab="currentTab" :outgoingSingleShipments="outgoingSingleShipments"  />


    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import HandOffTable from "../HandOffTable.vue";
// import DispatchTable from "./DispatchTable";
// import CummulativeIcon from "@/components/UI/svgs/CummulativeIcon.vue"
// import TopRoutesIcon from "@/components/UI/svgs/TopRoutesIcon.vue"

export default {
  components: {
    PageHeader,
     HandOffTable
    // DispatchTable,
    // CummulativeIcon,
    // TopRoutesIcon
  },
  data() {
    return {
      currentTab: "outgoing",
      currentShipmentTab: "singleShipment",
      outgoingSingleShipments: [], 
      dispatches: [],
      loadingDispatches: true,
      routes: [
        {
          name: "Ikeja → Surulere",
          qty: 5000,
        },
        {
          name: "Apapa → Victoria Island",
          qty: 2800,
        },
        {
          name: "Apapa → Ikeja",
          qty: 1500,
        },
        {
          name: "Ikeja → Lekki",
          qty: 1500,
        },
      ],
      handOffAnalytics: {}
    };
  },

  created() {
  },
  watch: {

  },
  mounted() {
    this.getAnalytics();
  },
  methods: {
    async getAnalytics() {
      try {
        this.loading = true;
        const { data: response } = await this.$_getHandoffToplineAnalytics();
        this.handOffAnalytics = response.data
        this.routes = response.data.topRoutes || []    
        this.outgoingSingleShipments = response.data.rows || [] 
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.metrics>:nth-child(1)>div {
  //  border: 1px solid red; 
   height: 100%;

}
.metrics>div  {
  // border: 1px solid blue; 
  p {
      color: #9B9B97;
      font-weight: 400;
      font-size: 12px;
    }
     h4 {
      color: #6B6B67;
      font-weight: 400;
      font-size: 12px;
    }
    h3{
      color: #1A1A18;
      font-weight: 600;
      font-size: 14px;  
    }
     span{
      color: #1A1A18;
      font-weight: 400;
      font-size: 14px;  
    }
    
     h2{
      color: #1A1A18;
      font-weight: 600;
      font-size: 28px;  
    }
    b{
      color: #10233E;
      font-size: 14px; 
    }
}

button {
  // border-radius: 2px;
}

.el-date-editor.el-input {
  // margin-bottom: 0;
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}

// .topline-wrapper{
//   border:1px solid gray;
//   border-style: dashed;
//   border-radius: 5px;
//   margin-top: 30px;
//   padding-bottom: 10px;
//   background-color: white;
//   box-sizing: content-box;
//   box-shadow: 10px 10px 30px rgb(227, 224, 224);

//   .topline{
//     background-color: #F2F7FC;
//     border-radius:10px ;
//     margin-top: 7px;
//     min-height: 72px;
//     padding-top: 16px;
//     padding-bottom: 16px;
//     vertical-align: middle;

//     .topline-child{
//       border-right: 1px dashed #4142455C;
//       min-height: 40px;
//       padding:0px 20px 10px 20px;
//       width: 20%;

//       .topline-header{
//         color:#7A90A7;
//         font-weight: 600;
//         font-size: 14px;
//       }

//       .topline-value{
//         color: #10233E;
//         font-weight: 600;
//         font-size: 16px;
//       }
//     }
//   }
// } 

// .pale-blue {
//   background-color: #10233e;
//   height: 40px;
// }
</style>